import React, {forwardRef} from "react"

export const Select = (props) => {
  return (
    <select {...props} id="select">
      {props.children}
    </select>
  )
}

export const Option = (props) => {
  return <option {...props}>{props.children}</option>
}

export const moveCaretAtEnd = (e) => {
  const tempValue = e.target.value
  e.target.value = ""
  e.target.value = tempValue
}

export const onEnterKeyPress = (callback, event) => {
  if (callback && event.charCode == 13) callback()
}

export const onEnterKeyPressThunk = (callback) => (event) => onEnterKeyPress(callback, event)

export const onEscapeKeyPress = (callback, event) => {
  if (callback && event.keyCode === 27) callback()
}

export const onEscapeKeyPressThunk = (callback) => (event) => onEscapeKeyPress(callback, event)

export const onTabKeyPress = (callback, event) => {
  if (callback && event.keyCode === 9) callback()
}

export const Textbox = forwardRef((props, ref) => {
  const {onEnter, onEscape, type} = props
  const textBoxProps = Object.assign({}, props)
  // Remove some props we don't care to render into the DOM'
  delete textBoxProps.onEnter
  delete textBoxProps.onEscape
  delete textBoxProps.textboxEl
  return <input type={type ? type : "text"} ref={ref} {...textBoxProps} onKeyPress={onEnterKeyPress.bind(null, onEnter)} onKeyUp={onEscapeKeyPress.bind(null, onEscape)} />
})

export const Email = (props) => <Textbox {...props} type="email" />

export const Password = (props) => <Textbox {...props} type="password" />

export const Hidden = ({name, value}) => <input type="hidden" name={name} value={value ? value : ""} />

export const Radio = ({checked, label, onChange}) => (
  <label className="radio">
    <input type="radio" checked={checked} onChange={onChange} aria-label={label} onKeyPress={onEnterKeyPress.bind(null, onChange)} />
    {label}
  </label>
)
